import apiClient from "./apiClient";

const LIST = (path) => `${path}?format=json`;
const DETAIL = (path, id) => `${path}${id}/?format=json`;

// hospitals
export const listHospitals = () => apiClient.get(LIST("/api/hospitals/"));
export const createHospital = (payload) => apiClient.post(LIST("/api/hospitals/"), payload);
export const getHospitalById = (id) => apiClient.get(DETAIL("/api/hospitals/", id));

// wards
export const listWards = () => apiClient.get(LIST("/api/wards/"));
export const createWard = (payload) => apiClient.post(LIST("/api/wards/"), payload);

// rooms
export const listRooms = () => apiClient.get(LIST("/api/rooms/"));
export const createRoom = (payload) => apiClient.post(LIST("/api/rooms/"), payload);

// beds
export const listBeds = () => apiClient.get(LIST("/api/beds/"));
export const createBed = (payload) => apiClient.post(LIST("/api/beds/"), payload);

// departments
export const listDepartments = () => apiClient.get(LIST("/api/departments/"));
export const createDepartment = (payload) => apiClient.post(LIST("/api/departments/"), payload);

// users
export const getUsers = () => apiClient.get(LIST("/api/users/"));
export const createUser = (payload) => apiClient.post(LIST("/api/users/"), payload);

export const uploadUserPhoto = (userId, file) => {
  const fd = new FormData();
  fd.append("photo", file);

  return apiClient.patch(DETAIL("/api/users/", userId), fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// roles
export const listRoles = () => apiClient.get(LIST("/api/roles/"));
export const createRole = (payload) => apiClient.post(LIST("/api/roles/"), payload);

// permissions
export const listPermissions = () => apiClient.get(LIST("/api/permissions/"));
export const createPermission = (payload) => apiClient.post(LIST("/api/permissions/"), payload);

// user-roles
export const listUserRoles = () => apiClient.get(LIST("/api/user-roles/"));
export const createUserRole = (payload) => apiClient.post(LIST("/api/user-roles/"), payload);

// role-permissions
export const listRolePermissions = () => apiClient.get(LIST("/api/role-permissions/"));
export const createRolePermission = (payload) =>
  apiClient.post(LIST("/api/role-permissions/"), payload);